/**
 * x-css-variable.a11y-font-size.root="fontSize"
 * @param Alpine
 */
export default function (Alpine) {
  Alpine.directive(
    "css-variable",
    (el, { modifiers, expression }, { effect, evaluateLater }) => {
      let propValueEvaluator = evaluateLater(expression);

      effect(() =>
        propValueEvaluator((value) => {
          const target = modifiers.includes("root")
            ? document.documentElement
            : el;
          modifiers.forEach((property) => {
            if (property !== "root") {
              target.style.setProperty(`--${property}`, value);
            }
          });
        })
      );

    }
  );
}
